
// ドロワーメニュー

export const init = () => {
    jQuery(function($){
        $(".js-openSub").click(function () {
            var submenu = $(this).closest(".header-menu--parent").find(".header-subMenu");
            submenu.slideToggle();
        });
    })
};
export default init;
